import { USE_MOCK_API } from './useMockApi'

/**
 * When `VITE_USE_MOCK_TPSM_INVENTORY=true`, `/tpsm/inventory` uses fixtures instead of live API:
 * - `fixtures/tpsm-suppliers.json` → GET /api/suppliers
 * - `fixtures/tpsm-criticality.json` → GET /api/tpsm/criticality
 * - `fixtures/tpsm-assessments-summary.json` → GET /api/tpsm/assessments/summary
 * Per-supplier assessments are derived from `recent` in the summary fixture.
 */
function readFlag(): boolean {
  const v = import.meta.env.VITE_USE_MOCK_TPSM_INVENTORY
  if (v == null || v === '') return false
  const s = String(v).trim().toLowerCase()
  return s === 'true' || s === '1' || s === 'yes' || s === 'on'
}

export const USE_MOCK_TPSM_INVENTORY_DATA = USE_MOCK_API || readFlag()
